import { FORM_FIELDS } from '../../../../constants';
import { getValidationSchema } from '../../common.validators';

export const schema = () =>
    getValidationSchema([
        FORM_FIELDS.AGREEMENT,
        FORM_FIELDS.PURPOSE,
        FORM_FIELDS.AMOUNT,
        FORM_FIELDS.REGION,
        FORM_FIELDS.REGION_LOCATION_ROUTE,
        FORM_FIELDS.EMAIL,
        FORM_FIELDS.PHONE,
        FORM_FIELDS.FIRST_NAME,
        FORM_FIELDS.LAST_NAME,
        FORM_FIELDS.MIDDLE_NAME,
        FORM_FIELDS.SMS_CODE,
        FORM_FIELDS.INITIAL_FEE,
        FORM_FIELDS.AUTO_BRAND,
        FORM_FIELDS.AUTO_MODEL,
        FORM_FIELDS.AUTO_YEAR,
    ]);
